module.exports = __webpack_public_path__ + "cd58fd18f126ecdca4cc7ef99b1d98f7.svg";